import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const categoryProductsApi = createAsyncThunk('categoryProduct', async (categoryId) => {
    const response = await axiosInstance.get(`/category/productList/${categoryId}`);
    return response.data;
});

const categoryProductsSlice = createSlice({
    name: "categoryProduct",
    initialState: {
        data: [],
        errors: [],
        status: "idle"
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(categoryProductsApi.pending, (state) => {
                state.status = "loading";
            })
            .addCase(categoryProductsApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = "idle";
            })
            .addCase(categoryProductsApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.status = "idle";
            });
    }
});

export default categoryProductsSlice.reducer;
